import { defineMessages } from 'react-intl';

export const validationMessages = defineMessages({
    canBeValidated: {
        id: 'can-be-validated',
        defaultMessage: 'Can be validated',
    },
    validateAsGuest: {
        id: 'validate-as-a-guest',
        defaultMessage: 'Validate as a guest',
    },
    validateChargePlan: {
        id: 'validate-charge-plan',
        defaultMessage: 'Validate charge plan',
    },
    cannotBeValidated: {
        id: 'cannot-be-validated',
        defaultMessage: 'Cannot be validated',
    },
    validate: {
        id: 'validate',
        defaultMessage: 'Validate',
    },
    validationConfirmation: {
        id: 'validation-confirmation',
        defaultMessage: 'Are you sure you want to validate the selected vehicle?',
    },
    validationSuccess: {
        id: 'validation-success',
        defaultMessage: 'Validation successful',
    },
    validationSuccessDetails: {
        id: 'validation-success-details',
        defaultMessage: 'Vehicle {vehicle} was successfully validated.',
    },
    vehicleIsValidated: {
        id: 'vehicle-is-validated',
        defaultMessage: 'Vehicle is validated',
    },
    validation: {
        id: 'validation',
        defaultMessage: 'Validation',
    },
    validationReason: {
        id: 'validation-reason',
        defaultMessage: 'Validation reason',
    },
});
